'use client';
import { useState } from 'react';

export default function CalculatorSalary() {
  const [annualSalary, setAnnualSalary] = useState(75000);
  const [taxRate, setTaxRate] = useState(22);
  const [deductions, setDeductions] = useState(5000);

  const taxableIncome = annualSalary - deductions;
  const totalTax = taxableIncome * (taxRate / 100);
  const takeHomePay = annualSalary - totalTax - deductions;
  const monthlyTakeHome = takeHomePay / 12;

  return (
    <div className="bg-white rounded-3xl p-8 shadow-modern-xl">
      <h2 className="text-2xl font-bold mb-6">Salary Details</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold mb-2">Annual Salary</label>
          <input type="number" value={annualSalary} onChange={(e) => setAnnualSalary(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Tax Rate (%)</label>
          <input type="number" step="0.1" value={taxRate} onChange={(e) => setTaxRate(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Annual Deductions</label>
          <input type="number" value={deductions} onChange={(e) => setDeductions(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
      </div>
      <div className="mt-8 space-y-4">
        <div className="p-6 bg-green-50 rounded-xl">
          <h3 className="text-lg font-bold mb-2">Annual Take-Home Pay</h3>
          <p className="text-3xl font-bold text-green-600">${takeHomePay?.toFixed(2)}</p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">Monthly Take-Home</p>
            <p className="text-xl font-bold text-slate-900">${monthlyTakeHome?.toFixed(2)}</p>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">Total Tax</p>
            <p className="text-xl font-bold text-slate-900">${totalTax?.toFixed(2)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
